import { createContext, useState } from "react";

export const InfoSeachContext = createContext({});

export function InfoSeachProvider({ children }) {
  const [dataColetaSearch, setDataColetaSearch] = useState([]);
  const [dataLocalSearch, setDataLocalSearch] = useState([]);
  const [locais, setLocais] = useState([]);
  const [filterLocais, setFilterLocais] = useState("");
  const [coletas, setColetas] = useState([]);
  const [filterColetas, setFilterColetas] = useState("");

  return (
    <InfoSeachContext.Provider
      value={{
        setDataColetaSearch,
        dataColetaSearch,
        setDataLocalSearch,
        dataLocalSearch,
        setLocais,
        locais,
        setFilterLocais,
        filterLocais,
        setColetas,
        coletas,
        setFilterColetas,
        filterColetas,
      }}
    >
      {children}
    </InfoSeachContext.Provider>
  );
}
